import normalizeUrl from "normalize-url";

export function isValidUrl(value: string): boolean {
  try {
    const normalizedUrl = normalizeUrl(value, {
      defaultProtocol: "https",
      stripWWW: false,
    });
    const parsedUrl = new URL(normalizedUrl);
    const segments = parsedUrl.host.split(".");

    return segments.length > 1;
  } catch {
    return false;
  }
}
